<template>
  <div>
    <Button type="info" ghost style="height:30px;margin-bottom:3px;margin-left:5px"  @click="fullWin">全屏</Button>
    <!-- <Button type="success" ghost style="height:30px;margin-bottom:3px;margin-left:5px"  @click="clipboard">粘贴板</Button> -->
    <iframe :src="url" style="width:100%;min-height:760px;over-flow:hidden"></iframe>
  </div>
</template>
<script>
import Tables from '_c/tables'
import Fullscreen from '_c/main/components/fullscreen'
export default {
  name: 'TabTerminal',
  props: ['url'],
  components: {
    Fullscreen,
    Tables
  },
  data () {
    return {
      isFullscreen: false
    }
  },
  methods: {
    fullWin () {
      // let h = window.screen.availHeight
      // let w = window.screen.availWidth
      window.open(this.url, '_blank')
      // window.open(this.url, 'target', 'left=0,top=0,width=' + w + ',height=' + h + ',directories=no,location=no,toolbar=no,menubar=no,status=no,scrollbars=no,titlebar=no,resizable=no')
    },
    clipboard () {
    }
  },
  wathch: {
  },
  mounted: function () {
  }
}
</script>

<style>
.ivu-poptip-body {
  text-align: left !important;
}
</style>
